import request from '@/utils/request'


// 查询运动量/膳食类型列表
export function listCreateType(query) {
  return request({
    url: '/create/createType/list',
    method: 'get',
    params: query
  })
}

// 查询运动量/膳食类型分页
export function pageCreateType(query) {
  return request({
    url: '/create/createType/page',
    method: 'get',
    params: query
  })
}

// 查询运动量/膳食类型详细
export function getCreateType(data) {
  return request({
    url: '/create/createType/detail',
    method: 'get',
    params: data
  })
}

// 新增运动量/膳食类型
export function addCreateType(data) {
  return request({
    url: '/create/createType/add',
    method: 'post',
    data: data
  })
}

// 修改运动量/膳食类型
export function updateCreateType(data) {
  return request({
    url: '/create/createType/edit',
    method: 'post',
    data: data
  })
}

// 删除运动量/膳食类型
export function delCreateType(data) {
  return request({
    url: '/create/createType/delete',
    method: 'post',
    data: data
  })
}
